import React, {useEffect, useState} from "react";
import moment from "moment";
import 'react-dates/initialize';
import UseWindowSize from "../../hooks/UseWindowSize";
import {SingleDatePicker} from "react-dates";

moment.locale("nl");

interface DateRangePickerProps {
    pickerName: string
    placeHolderText: string
    onDateChange: (date: moment.Moment) => void
    isOutsideRange: (date: moment.Moment) => boolean
    initialDate?: moment.Moment
}

const DatePicker = ({ placeHolderText, pickerName, onDateChange, isOutsideRange, initialDate }: DateRangePickerProps) => {
    const [date, setDate] = useState(initialDate);
    const [focused, setFocused] = useState(false);
    const size = UseWindowSize();

    useEffect(() => {
        onDateChange(date);
    }, [date])

    useEffect(() => {
        if (!date) {
            setDate(initialDate);
            return;
        }

        if (date.format('YYYY-MM-DD') !== initialDate.format('YYYY-MM-DD')) {
            setDate(initialDate);
        }
    }, [initialDate])

    return (
        <div className="date-range-picker">
            <SingleDatePicker
                isOutsideRange={isOutsideRange}
                date={date}
                calendarInfoPosition="top"
                displayFormat="DD MMM YYYY"
                placeholder={placeHolderText}
                hideKeyboardShortcutsPanel
                block={true}
                onDateChange={(date) =>
                    setDate(date)
                }
                id={pickerName}
                focused={focused}
                onFocusChange={( { focused } ) => setFocused(focused)}
                orientation={size.width < 400 ? "vertical" : "horizontal"}
            />
        </div>
    );
}

export default DatePicker;
